const captchaSiteKey = "6LfgpOkkAAAAAACkUE0XK-iCzEINLzSES_QKwYcO";

export default captchaSiteKey;